import { render, staticRenderFns } from "./practitionerimageuploader.component.vue?vue&type=template&id=3edda917&scoped=true"
import script from "./practitionerimageuploader.component.vue?vue&type=script&lang=js"
export * from "./practitionerimageuploader.component.vue?vue&type=script&lang=js"
import style0 from "./practitionerimageuploader.component.vue?vue&type=style&index=0&id=3edda917&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edda917",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VCard,VImg})
